<template>
  <page-content title="Rekapitulasi" :with-margin="false">
    <br />
    <div class="ml-3 mr-3">
      <div class="input-self-error">
        <c-input-select
          label="Departemen"
          v-model="form.departmentId"
          :options="departmentOptions"
        />
        <p class="self-error-message" v-if="validations.departmentId.error">
          {{ validations.departmentId.message }}
        </p>
      </div>

      <c-input-select
        label="Tanggal Periksa"
        v-model="form.date"
        :options="dateOptions"
      />
    </div>
    <!-- Result go here -->
    <template v-if="form.departmentId != '' && form.date != ''">
      <h2 class="ml-3 mt-3 mb-2">
        Berikut adalah daftar peserta yang melakukan pemeriksaan
      </h2>
      <download-excel
        v-if="checkupReports.length > 10"
        class="btn-report-download ml-3 mr-3"
        :data="checkupReports"
        :fields="json_fields"
        :name="excelFilename"
      >
        Unduh Excel
      </download-excel>
      <ul class="patient-list-wrap">
        <li
          class="patient-list-item"
          v-for="checkup in checkupReports"
          :key="checkup.id"
        >
          <h4>{{ checkup.user.fullname }}</h4>
          <p>{{ checkup.user.profession }}</p>
        </li>
      </ul>
      <download-excel
        v-if="checkupReports.length > 0"
        class="btn-report-download ml-3 mr-3"
        :data="checkupReports"
        :fields="json_fields"
        :name="excelFilename"
        >Unduh Excel
      </download-excel>
    </template>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";
import JsonExcel from "vue-json-excel";

export default {
  name: "registration",
  components: {
    "download-excel": JsonExcel,
  },
  data: function () {
    return {
      isLoading: false,
      form: {
        departmentId: "",
        date: "",
      },
      originalForm: {},
      validations: {
        departmentId: {
          error: false,
          message: "",
        },
        date: {
          error: false,
          message: "",
        },
      },
      json_fields: {
        "Tanggal Periksa": {
          field: "date",
          callback: (val) => {
            return this.formatDateForHuman(val);
          },
        },
        "Nama Lengkap": "user.fullname",
        "Jenis Kelamin": {
          field: "user.gender",
          callback: (val) => {
            return val == "F" ? "Perempuan" : "Laki-laki";
          },
        },
        Pekerjaan: "user.profession",
        Merokok: {
          field: "smoking",
          callback: (val) => {
            if (val == "1") return "Ya";
            else if (val == "0") return "Tidak";
            return "-";
          },
        },
        "Makan Sayur dan Buah < 5 porsi sehari": {
          field: "lack_vegetable_fruit",
          callback: (val) => {
            if (val == "1") return "Ya";
            else if (val == "0") return "Tidak";
            return "-";
          },
        },
        "Kurang Aktivitas Fisik": {
          field: "lack_physical_activity",
          callback: (val) => {
            if (val == "1") return "Ya";
            else if (val == "0") return "Tidak";
            return "-";
          },
        },
        "Konsumsi Minuman Beralkohol": {
          field: "alcohol",
          callback: (val) => {
            if (val == "1") return "Ya";
            else if (val == "0") return "Tidak";
            return "-";
          },
        },
        "Berat Badan": "weight",
        "Tinggi Badan": "height",
        "Lingkar Perut": "waist",
        "Tekanan Darah": {
          callback: (val) => {
            return val.systolic_pressure + "/" + val.diastolic_pressure;
          },
        },
        Kolesterol: "cholesterol",
        "Gula Darah": "blood_sugar",
        "Asam Urat": "urid_acid",
        "Masalah yang Ditemukan": "problem",
        "Saran dan Tindak lanjut": "suggestion",
        "Tanggal Dirujuk": {
          field: "referral_date",
          callback: (val) => {
            return !this.isEmpty(val) ? this.formatDateForHuman(val) : "";
          },
        },
        "Alasan Rujukan": "referral_reason",
      },
    };
  },
  computed: {
    ...mapGetters({
      departments: "departments",
      availableDates: "availableDates",
      checkupReports: "checkupReports",
    }),
    excelFilename: function () {
      var filename = "Rekap-Posbindu";
      if (this.form.departmentId != "") {
        var dep = this.departments.find((d) => d.id == this.form.departmentId);
        filename += "-" + dep.alias;
      }
      if (this.form.date != "") {
        filename += "-" + this.form.date;
      }
      return filename + ".xls";
    },
    departmentOptions: function () {
      const options = [
        {
          value: "",
          text: "Pilih departemen",
        },
      ];
      for (var i = 0; i < this.departments.length; i++) {
        options.push({
          value: this.departments[i].id,
          text: this.departments[i].name,
        });
      }
      return options;
    },
    dateOptions: function () {
      const options = [
        {
          value: "",
          text: "Pilih tanggal periksa",
        },
      ];
      for (var i = 0; i < this.availableDates.length; i++) {
        options.push({
          value: this.availableDates[i].date,
          text: this.formatDateForHuman(this.availableDates[i].date),
        });
      }
      return options;
    },
  },
  watch: {
    "form.departmentId": function (val) {
      this.$store.dispatch("resetAvailableDates");
      this.$store.dispatch("resetCheckupReports");
      this.form.date = "";
      if (val != "") {
        this.$store.dispatch("getAvailableDates", val);
      }
    },
    "form.date": function (val) {
      if (val != "") {
        this.doSubmit();
      }
    },
  },
  methods: {
    isFormValid: function () {
      // Reset the errors
      this.validations.departmentId.error = false;
      this.validations.date.error = false;

      if (this.isEmpty(this.form.departmentId)) {
        this.validations.departmentId.error = true;
        this.validations.departmentId.message = "Departemen harus diisi.";
      }
      if (this.isEmpty(this.form.date)) {
        this.validations.date.error = true;
        this.validations.date.message = "Tanggal periksa harus diisi.";
      }

      for (const key in this.validations) {
        const field = this.validations[key];
        if (field["error"]) return false;
      }
      return true;
    },
    doSubmit: function () {
      if (this.isFormValid()) {
        this.isLoading = true;
        this.$store
          .dispatch("getCheckupReports", this.form)
          .then(() => {
            // Reset form
            this.isLoading = false;
          })
          .catch((error) => {
            const messages = error.response.data.message;
            if (messages.hasOwnProperty("department_id")) {
              this.validations.department_id.error = true;
              this.validations.department_id.message =
                messages.department_id[0];
            }
            if (messages.hasOwnProperty("date")) {
              this.validations.date.error = true;
              this.validations.date.message = messages.date[0];
            }
            this.isLoading = false;
          });
      }
    },
  },
  created: function () {
    this.$store.dispatch("getAllDepartments");
    this.originalForm = this.form;
  },
};
</script>
